var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    {
      staticClass: "products-table",
      style: { width: "100%" },
      attrs: { id: "products-table", tag: "table", x: "", y: false },
    },
    [
      _c("thead", { staticClass: "head" }, [
        _c("tr", [
          _c(
            "th",
            { staticStyle: { width: "20px" } },
            [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
            1
          ),
          _c("th", { staticClass: "qty", staticStyle: { width: "80px" } }, [
            _vm._v(" " + _vm._s(_vm.$ct("sales-row.Qty")) + " "),
          ]),
          _c("th", { staticClass: "qty", staticStyle: { width: "80px" } }, [
            _vm._v(" " + _vm._s(_vm.$ct("sales-row.Unit")) + " "),
          ]),
          _c("th", { staticClass: "description" }, [
            _vm._v(" " + _vm._s(_vm.$ct("sales-row.Name")) + " "),
          ]),
          _c(
            "th",
            { staticClass: "align-r", staticStyle: { width: "122px" } },
            [_vm._v(" " + _vm._s(_vm.$ct("sales-row.UnitPrice")) + " ")]
          ),
          _c(
            "th",
            { staticClass: "align-r", staticStyle: { width: "100px" } },
            [_vm._v(" " + _vm._s(_vm.$ct("sales-row.Discount")) + " ")]
          ),
          _c("th", { staticClass: "align-r", staticStyle: { width: "60px" } }, [
            _vm._v(" " + _vm._s(_vm.$ct("sales-row.Vat")) + " "),
          ]),
          _c(
            "th",
            { staticClass: "align-r", staticStyle: { width: "100px" } },
            [_vm._v(" " + _vm._s(_vm.$ct("sales-row.NettoPrice")) + " ")]
          ),
          _c(
            "th",
            { staticClass: "align-r", staticStyle: { width: "100px" } },
            [_vm._v(" " + _vm._s(_vm.$ct("sales-row.BrutoPrice")) + " ")]
          ),
          _c("th", { style: { width: "28px", paddingTop: "5px" } }),
        ]),
      ]),
      _c(
        "w-scroll-view",
        {
          staticClass: "body",
          attrs: {
            tag: "w-sortable",
            "tag-attributes": _vm.sortableAttributes,
          },
        },
        _vm._l(_vm.items, function (row, i) {
          return _c("app-row", {
            key: i,
            attrs: {
              "row-index": i,
              row: row,
              "is-selected": _vm.selectedRow == row,
            },
            on: {
              edit: function ($event) {
                return _vm.onEditRow(row)
              },
              select: function ($event) {
                return _vm.onRowSelect($event)
              },
              remove: function ($event) {
                return _vm.onRemove(row)
              },
              insert: function ($event) {
                return _vm.onInsertRow()
              },
              bold: function ($event) {
                return _vm.onBold(row)
              },
              hide: function ($event) {
                return _vm.onHide(row)
              },
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }